import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { UpdateTag } from '../reducers/update-tag.reducer';
import * as selectors from '../selectors/update-tag.selectors';

@Injectable()
export class UpdateTagFacadeService extends FacadeService {
  constructor(public override store: Store<UpdateTag>) {
    super(store);
  }

  tagLabel$ = this.storeSelect(selectors.getTagLabel);
  tagCode$ = this.storeSelect(selectors.getTagCode);
  tagType$ = this.storeSelect(selectors.getTagType);
  updateTagDisabled$ = this.storeSelect(selectors.getUpdateTagDisabled);
  tagTypeValidation$ = this.storeSelect(selectors.getTagTypeValidation);
  tagCodeValidation$ = this.storeSelect(selectors.getTagCodeValidation);
  tagLabelValidation$ = this.storeSelect(selectors.getTagLabelValidation);
  formIsValid$ = this.storeSelect(selectors.getFormIsValid);

  get tagLabel() {
    return this.storeSnapshot(this.tagLabel$);
  }

  get tagCode() {
    return this.storeSnapshot(this.tagCode$);
  }

  get tagType() {
    return this.storeSnapshot(this.tagType$);
  }

  get formIsValid() {
    return this.storeSnapshot(this.formIsValid$);
  }
}
